export var IUsageTypes;
(function (IUsageTypes) {
    IUsageTypes[IUsageTypes["OneOne"] = 0] = "OneOne";
    IUsageTypes[IUsageTypes["Channel"] = 1] = "Channel";
})(IUsageTypes || (IUsageTypes = {}));
